import { Link } from 'react-router-dom';
import styles from './ButtonLink.module.css';


export default function ButtonLink({ path, children, fontSize, type = 'type1' }) {
  const customStyles = {
    fontSize: fontSize || undefined
  };

  const buttonClass = `${styles.button} ${type === 'type2' ? styles.type2 : ''}`;

  if (!path) {
    return (
      <button className={buttonClass} style={customStyles}>
        {children}
      </button>
    );
  }

  return (
    <Link to={path} className={buttonClass} style={customStyles}>
      {children}
    </Link>
  );
}
